import React, { useMemo } from 'react';

import { ReactComponent as WordIcon } from '../../../../assets/icons/file-preview/word_small.svg';
import { ReactComponent as ExcelIcon } from '../../../../assets/icons/file-preview/excel_small.svg';
import { ReactComponent as PowerpointIcon } from '../../../../assets/icons/file-preview/powerpoint_small.svg';
import FileIcon from '@mui/icons-material/Description';
import PdfIcon from '@mui/icons-material/PictureAsPdf';
import { FileType } from '../../../../utils/file-utils';
import { useStyles } from './OtherFileViewer.styles';
import theme from '../../../../styles/theme';

interface OtherFileViewerProps {
  type: FileType;
}

export default function OtherFileViewer({ type }: OtherFileViewerProps) {
  const { classes } = useStyles(theme);

  const filePreview = useMemo(() => {
    switch (type) {
      case FileType.word:
        return <WordIcon />;
      case FileType.exel:
        return <ExcelIcon />;
      case FileType.powerpoint:
        return <PowerpointIcon />;
      case FileType.pdf:
        return <PdfIcon />;
      default:
        return <FileIcon />;
    }
  }, [type]);

  return (
    <div className={classes.otherFileViewerWrapper}>
      <div>{filePreview}</div>
    </div>
  );
}
